<script setup lang="ts">
import type { Order } from "@/model/backend/order"
import { useApp } from "@/vf"
import { computed } from "vue"

const props = defineProps<{ order: Order }>()
const { apiLink } = useApp()

const pickupConfirmations =
    computed(() => props.order.uploads?.filter(upload => upload.type === "pickup_confirmation")) ?? []
</script>

<template>
    <a
        v-for="upload in pickupConfirmations"
        :key="upload.id"
        class="pl-md-1"
        target="_blank"
        :href="apiLink('shop/my-account/upload/' + upload.id)"
    >
        <img src="@/shop/assets/icons/pdf-inverted.png" width="20" alt="Datei" />
    </a>
</template>
